// extracted by mini-css-extract-plugin
export default {"eventsGrid":"Vendor_eventsGrid__p0-XY","tableHeader":"Vendor_tableHeader__SRp7t"};